import { JourneyPlace } from '../../lib/types/models/journey-place/journey-place'
import { JourneyPlaceInput } from '../../lib/types/models/journey-place/journey-place-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateJourneyPlace(data: UpdateInput<JourneyPlaceInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.journeyPlaces.update.url, { id }))
    .patch<JourneyPlace>(rest)
}
